import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useCustomerAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useStoreBase } from "@/lib/store";
import { useTranslation } from "react-i18next";

export default function StorefrontMyOrders({ config }) {
  const { t } = useTranslation();
  const { slug, base } = useStoreBase();
  const { user, loading } = useCustomerAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get(`/store/${slug}/my-orders`).then(({ data }) => setOrders(data));
  }, [slug, user]);

  if (loading) return <div className="p-12 text-center text-stone-500">{t("common.loading")}</div>;
  if (!user) return <Navigate to={`${base}/account/login`} replace />;

  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <h1 className="font-display text-3xl font-bold text-stone-900">{t("store.yourOrders")}</h1>
      <div className="mt-6 space-y-3">
        {orders.length === 0 ? (
          <Card className="p-8 text-center text-stone-500 text-sm border-stone-200/70">{t("store.noOrdersYet")}</Card>
        ) : orders.map((o) => (
          <Link to={`${base}/order/${o.id}`} key={o.id}>
            <Card className="p-4 border-stone-200/70 hover:shadow-sm flex items-center gap-4" data-testid={`my-order-${o.order_number}`}>
              <div className="flex-1">
                <div className="font-mono-nums font-semibold text-stone-900">{o.order_number}</div>
                <div className="text-xs text-stone-500">{new Date(o.created_at).toLocaleString("en-IN")} · {o.items.length} items</div>
              </div>
              <div className="text-right">
                <div className="font-mono-nums font-semibold">₹{o.total.toLocaleString("en-IN")}</div>
                <Badge className="bg-stone-100 text-stone-700 border-0 capitalize">{o.status}</Badge>
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
